// deck.gl-community
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
export class LayerMouseEvent {
    canceled = false;
    // original item that this event is related to
    data;
    // internal nebula info about the object
    metadata;
    // the mouse [lng,lat] raycasted onto the ground
    groundPoint;
    // browser event
    nativeEvent;
    // reference to nebula
    nebula;
    constructor(nativeEvent, { data, groundPoint, nebula, metadata }) {
        this.nativeEvent = nativeEvent;
        this.data = data;
        this.groundPoint = groundPoint;
        this.nebula = nebula;
        this.metadata = metadata;
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.canceled = true;
    }
}
//# sourceMappingURL=layer-mouse-event.js.map